// icon:bxs-landmark | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Politics.png";

function IconBxsLandmark(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Politics"} />
	)
}

export default IconBxsLandmark;
